import { Component, OnInit , AfterViewInit, ViewEncapsulation, ViewChild, ElementRef } from '@angular/core';
import { Location } from '@angular/common';
import Keyboard from 'simple-keyboard';
import { ActivatedRoute } from '@angular/router';
import { TotemService } from '../totem.service';
import { Tienda } from '../tiendas/tienda';
import { Categoria } from '../tiendas/categoria';
import { TipoAccesos } from '../servicios/accesos';
import { QRCodeModule } from 'angularx-qrcode';
import { ControlPosition } from '@agm/core/services/google-maps-types';
import { environment } from '../../environments/environment';
@Component({
  selector: 'app-enviarruta',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './enviarruta.component.html',
  styleUrls: ['./enviarruta.component.css']
})
export class EnviarrutaComponent implements OnInit, AfterViewInit {
  tiporuta;
  idruta;
  tiendas;
  tiendasel;
  datostienda;
  categoriatienda;
  servicioactual;
  serviciosresult;
  colorest;
  estacionamientonombre;
  totemConfig;
  idtotem;
  estacionamientosid = environment.idEst;
  colorEstacionamiento = environment.colorEst;
  preferenciaruta = environment.tipoTransporte.pie.toString();

  ngxQrcode2 = 'https://www.npmjs.com/package/ngx-qrcode2';
  techiediaries = 'https://www.npmjs.com/~techiediaries';
  letsboot = 'https://www.letsboot.com/';

  // codigo = 'http://rutarealplaza.mzzo.com/#/';
  codigo = 'https://rutastotem.mzzo.com/#/';
  myAngularxQrCode = '';
  // ':totem/:piid/:opt/:acc/:transporte'
  commonKeyboardOptions = {
    onKeyPress: (button: string) => this.onKeyPress(button)
  };
  constructor(
    private route: ActivatedRoute,
    private totemService: TotemService,
    private location: Location) { }

  async ngOnInit() {
    this.totemConfig = await this.totemService.getTotemConfig();
    this.idtotem = this.totemConfig.id;
    this.idruta = this.route.snapshot.paramMap.get('id');
    this.tiporuta = this.route.snapshot.paramMap.get('tipo');
    this.preferenciaruta = this.route.snapshot.paramMap.get('transs');
    // logica tiendas
    if (this.tiporuta === 'tienda') {
      this.myAngularxQrCode = this.codigo + this.idtotem + '/' + this.idruta + '/' + this.tiporuta + 's/0/' + this.preferenciaruta;
      console.log('ruta', this.myAngularxQrCode);
      const tiendas = await this.totemService.getTiendas().toPromise();
      this.tiendas = tiendas.map((tienda: any) => new Tienda(tienda));
      for (const tienda of tiendas) {
        this.idruta = parseInt(this.idruta, 10);
        if (tienda.punto_interes === this.idruta) {
          this.datostienda = tienda;
        }
      }
      const items = await this.totemService.getCategorias().toPromise();
      const categorias = items.map(item => new Categoria(item));
      for (const cate of categorias) {
        if (cate.id === this.datostienda.categoria) {
          const nombre = cate.nombre.toLowerCase();
          cate.nombre = nombre.charAt(0).toUpperCase() + nombre.slice(1);
          this.categoriatienda = cate;
        }
      }
    }
    // logica servicios
    if (this.tiporuta === 'servicios') {
      this.myAngularxQrCode = this.codigo + this.idtotem + '/0'  + '/' + this.tiporuta + '/' + this.idruta + '/' + this.preferenciaruta;
      console.log('ruta', this.myAngularxQrCode);
      const tipoAccesos = await this.totemService.getTipoAccesos().toPromise();
      this.serviciosresult = tipoAccesos.map(
        tipoAcceso => new TipoAccesos(tipoAcceso)
      );
      this.idruta = parseInt(this.idruta, 10);
      for (const ser of this.serviciosresult) {
        if (ser.id === this.idruta) {
          this.servicioactual = ser;
        }
      }
      console.log('el servicio', this.servicioactual);
    }
    // logica estacionamientos
    if (this.tiporuta === 'estacionamiento') {
      this.myAngularxQrCode = this.codigo + this.idtotem + '/' + this.idruta + '/' + this.tiporuta + '/0/' + this.preferenciaruta;
      const idnum = Number(this.idruta);
      const numeroIndice = this.estacionamientosid.indexOf(idnum);
      this.estacionamientonombre = this.colorEstacionamiento[numeroIndice];
      this.colorest = this.estacionamientonombre;
    }

  }
  public goBack() {
    this.location.back();
  }

  value = "";
  keyboard: Keyboard;
  selectedInputElem: any;

  ngAfterViewInit() {
    this.keyboard = new Keyboard({
      ...this.commonKeyboardOptions,
      layout: {
        default:[
          '1 2 3 4 5 6 7 8 9 0 {bksp}',
          'q w e r t y u i o p',
          'a s d f g h j k l ñ',
          'z x c v b n m `',
          '.com @ {space}']
        },
      display: {
        '{Cancelar}': ' Cancelar ',
        '{bksp}': ' ⌫',
        '{space}': '<i class="material-icons"></i>',
      },
      debug: true,
      onChange: input => this.onChange(input),
      onKeyPress: button => this.onKeyPress(button),
      preventMouseDownDefault: true
    });

    this.selectedInputElem = document.querySelector('.input:first-child');

    document.querySelectorAll('.input').forEach(input => {
      input.addEventListener('focus', this.onInputFocus);
      input.addEventListener('input', this.onInputChange);
    });
  }

  onInputFocus = (event: any) => {
    this.selectedInputElem = event.target;
    this.keyboard.setOptions({
      inputName: event.target.id
    });
  }

  setInputCaretPosition = (elem: any, pos: number) => {
    if (elem.setSelectionRange) {
      elem.focus();
      elem.setSelectionRange(pos, pos);
    }
  }

  onInputChange = (event: any) => {
    this.keyboard.setInput(event.target.value, event.target.id);
  }

  onChange = (input: string) => {
    this.selectedInputElem.value = input;
    const caretPosition = this.keyboard.caretPosition;
    if (caretPosition !== null) {
      this.setInputCaretPosition(this.selectedInputElem, caretPosition);
    }
  }

  onKeyPress = (button: string) => {
  }

  handleShift = () => {
    const currentLayout = this.keyboard.options.layoutName;
    const shiftToggle = currentLayout === 'default' ? 'shift' : 'default';

    this.keyboard.setOptions({
      layoutName: shiftToggle
    });
  }
}
